import {BASESITEID} from '../components/common/constants';
export const getCreateconsignmentAddApiEndpoint = `/occ/v2/${localStorage.getItem(
    'baseSiteId'
) ? localStorage.getItem(
    'baseSiteId'
) : BASESITEID}/consignment/consignmentAdd`;

export const getconsignmentAddProductSearchEndpoint = (queryParams) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/products/productList?${queryParams}`;

export const getconsignmentAddValidatedProducts = `occ/v2/${localStorage.getItem(
    'baseSiteId'
)}/products/validateproduct?`;

export const getValidateMazorCodeEndpoint = (code) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/usage/validatemazorcode?mazorKitCode=${code}`;

export const getconsignmentAddCategoryAndBrandsApiEndpoint = (territoryIdValue) => `/occ/v2/${localStorage.getItem(
    'baseSiteId'
) ? localStorage.getItem(
    'baseSiteId'
) : BASESITEID}/products/productBrandAndCategoryList?orderType=KB&territoryId=${territoryIdValue}`;

export const getconsignmentAddProductsByBrandOrSuperCategoryApiEndpoint = (
    queryParams
) =>
    `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/products/productDetailsByFacetCategoryBrand?${queryParams}`;

export const getProductDetailsApiEndpoint = (
    productCFN,
    salesOrg,
    orderType,
    resourceType
) =>
    `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/products/productDetails/${productCFN}?salesOrg=${salesOrg}&orderType=${orderType}&resourceType=${resourceType}`;

export const getValidatedProductsEndpoint =(queryParams)=> `occ/v2/${localStorage.getItem(
    'baseSiteId'
)}/products/validateproduct?${queryParams}`;

export const getDetailedconsignmentAddProductTemplatesEndpoint = (queryParams) => 
    `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/productTemplates/templateslist?${queryParams}`;

export const getconsignmentAddTemplateDetailsEndpoint = (queryParams) => 
    `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/productTemplates/templatesdetails/${queryParams}`;

export const createconsignmentAddProductTemplateEndpoint = 
    `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    ) ? localStorage.getItem(
        'baseSiteId'
    ) : BASESITEID}/templates`;

export const updateconsignmentAddProductTemplateEndpoint = 
    `/occ/v2/${localStorage.getItem('baseSiteId')}/templates`;

export const getDataForconsignmentAddTemplateEndpoint = (myCASERef, orderType) => 
    `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/productTemplates/templatesdetails/${
        myCASERef
    }?isMyCASERef=true&orderType=${orderType}`;

export const getPricesForItemsEndpoint = (queryParams) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/usage/price?${queryParams}`;

export const getDropdownEnpoint = (dropdown) => {
    const url = `/occ/v2/${localStorage.getItem('baseSiteId')}/order/`;
    switch (dropdown) {
        case 'priceoverridereasons':
            return `${url}priceoverridereasons`;
        case 'procedures':
            return `${url}Surgery/procedure`;
        default:
            return '';
    }
};
    